import React, { useState, useRef } from 'react';
import { Layout } from '../components/Layout';
import { SEO, pageSEO } from '../components/SEO';
import { Card, CardContent } from '../components/ui/Card';
import { BookOpen, Users, Briefcase, Music, ArrowRight, CheckCircle2, Calendar, Recycle, X, Loader2, GraduationCap, Award, Sparkles, Building2, Handshake, UserPlus, PartyPopper, RefreshCw } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { saveSubmission } from '../services/databaseService';
type ModalType = 'ateliers' | 'festival' | 'employeur' | 'recruter' | 'partenariat' | 'recyclage' | null;
export function ActionsPage() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [formationAutre, setFormationAutre] = useState('');
  const [showFormationAutre, setShowFormationAutre] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    const formData = new FormData(formRef.current!);
    const data: Record<string, any> = {};
    formData.forEach((value, key) => {
      if (data[key]) {
        // Handle multiple values (checkboxes)
        if (Array.isArray(data[key])) {
          data[key].push(value);
        } else {
          data[key] = [data[key], value];
        }
      } else {
        data[key] = value;
      }
    });
    // Map form data to submission types
    let submission: any = {
      type: ''
    };
    switch (activeModal) {
      case 'ateliers':
        submission = {
          type: 'atelier',
          nom: data.nom || '',
          prenom: data.prenom || '',
          dateNaissance: data.dateNaissance || '',
          sexe: data.sexe || '',
          situation: data.situation || '',
          niveauEtudes: data.niveauEtudes || '',
          ville: data.ville || '',
          quartier: data.quartier || '',
          telephone: data.telephone || '',
          email: data.email || '',
          formationSouhaitee: data.formationSouhaitee || '',
          formationAutre: formationAutre || '',
          source: data.source || '',
          motivations: data.motivations || ''
        };
        break;
      case 'festival':
        submission = {
          type: 'festival',
          nom: data.nom || '',
          prenom: data.prenom || '',
          telephone: data.telephone || '',
          email: data.email || '',
          profil: data.profil || '',
          participation: data.participation || '',
          message: data.message || ''
        };
        break;
      case 'employeur':
        submission = {
          type: 'employeur',
          nom: data.nom || '',
          prenom: data.prenom || '',
          typeEmployeur: data.typeEmployeur || '',
          ville: data.ville || '',
          telephone: data.telephone || '',
          email: data.email || '',
          profilsRecherches: data.profilsRecherches || '',
          attentes: data.attentes || ''
        };
        break;
      case 'recruter':
        submission = {
          type: 'recruter',
          nom: data.nom || '',
          prenom: data.prenom || '',
          telephone: data.telephone || '',
          email: data.email || '',
          ville: data.ville || '',
          quartier: data.quartier || '',
          typePersonnel: data.typePersonnel || '',
          typeContrat: data.typeContrat || '',
          dateDebut: data.dateDebut || '',
          description: data.description || ''
        };
        break;
      case 'partenariat':
        submission = {
          type: 'partenariat',
          organisation: data.organisation || '',
          typeOrganisation: data.typeOrganisation || '',
          nomContact: data.nomContact || '',
          fonction: data.fonction || '',
          telephone: data.telephone || '',
          email: data.email || '',
          typePartenariat: data.typePartenariat || '',
          proposition: data.proposition || ''
        };
        break;
      case 'recyclage':
        // Collect checked points
        const pointsFormation: string[] = [];
        document.querySelectorAll('input[name="pointsFormation"]:checked').forEach(el => {
          pointsFormation.push((el as HTMLInputElement).value);
        });
        submission = {
          type: 'recyclage',
          nomEmployeur: data.nomEmployeur || '',
          telephoneEmployeur: data.telephoneEmployeur || '',
          emailEmployeur: data.emailEmployeur || '',
          villeEmployeur: data.villeEmployeur || '',
          nomEmploye: data.nomEmploye || '',
          posteActuel: data.posteActuel || '',
          anciennete: data.anciennete || '',
          telephoneEmploye: data.telephoneEmploye || '',
          pointsFormation: pointsFormation,
          autresPoints: data.autresPoints || '',
          periodeSouhaitee: data.periodeSouhaitee || '',
          dureeSouhaitee: data.dureeSouhaitee || '',
          observations: data.observations || ''
        };
        break;
    }
    // Save to database
    setTimeout(() => {
      try {
        saveSubmission(submission);
        setIsSubmitting(false);
        setIsSuccess(true);
      } catch (error) {
        console.error('Error saving submission:', error);
        setIsSubmitting(false);
        alert('Une erreur est survenue. Veuillez réessayer.');
      }
    }, 1000);
  };
  const closeModal = () => {
    setActiveModal(null);
    setIsSuccess(false);
    setShowFormationAutre(false);
    setFormationAutre('');
  };
  const handleFormationChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setShowFormationAutre(e.target.value === 'autre');
  };
  const inputClass = 'w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all';
  const selectClass = 'w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all bg-white';
  const labelClass = 'text-sm font-medium text-gray-700';
  const modalConfigs = {
    ateliers: {
      title: 'Inscription aux Ateliers',
      subtitle: 'Mars 2026 - Remplissez ce formulaire pour candidater',
      successMessage: 'Candidature envoyée ! Notre équipe examinera votre profil et vous contactera très prochainement.'
    },
    festival: {
      title: 'Participation au Festival',
      subtitle: 'Juin 2026 - Inscrivez-vous pour participer au Festival des Personnels de Maison',
      successMessage: "Inscription enregistrée ! Vous recevrez bientôt les détails de l'événement."
    },
    employeur: {
      title: 'Devenir Employeur Partenaire',
      subtitle: "Rejoignez notre réseau d'employeurs engagés pour un emploi digne",
      successMessage: 'Demande envoyée ! Notre équipe vous contactera pour finaliser votre adhésion.'
    },
    recruter: {
      title: 'Recruter un Personnel Formé',
      subtitle: 'Décrivez vos besoins et nous vous mettrons en relation avec des profils qualifiés',
      successMessage: 'Demande reçue ! Nous vous proposerons des profils correspondant à vos critères.'
    },
    partenariat: {
      title: 'Proposer un Partenariat',
      subtitle: "Collaborons ensemble pour l'insertion professionnelle digne",
      successMessage: 'Proposition reçue ! Notre équipe étudiera votre demande et vous recontactera.'
    },
    recyclage: {
      title: 'Recycler mon Employé',
      subtitle: 'Offrez une formation de mise à niveau à votre personnel',
      successMessage: 'Demande enregistrée ! Nous vous contacterons pour organiser la formation.'
    }
  };
  return <Layout data-id="element-197">
      <SEO {...pageSEO.actions} data-id="element-198" />
      {/* Header */}
      <div className="bg-[#2C3E50] text-white py-16" data-id="element-199">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-200">
          <h1 className="text-4xl font-bold mb-4" data-id="element-201">Nos Actions</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-202">
            Les actions de l'ADCC s'articulent autour de quatre piliers
            complémentaires : la formation professionnelle, la valorisation
            sociale et culturelle, le placement et l'insertion professionnelle,
            et le recyclage des compétences.
          </p>
        </div>
      </div>

      {/* Four Pillars Introduction */}
      <section className="py-16 bg-white" data-id="element-203">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-204">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-205">
            {[{
            icon: BookOpen,
            title: 'Formation Professionnelle',
            desc: 'Acquisition de compétences techniques certifiantes'
          }, {
            icon: Users,
            title: 'Valorisation Sociale',
            desc: 'Reconnaissance et dignité des métiers de service'
          }, {
            icon: Briefcase,
            title: 'Placement & Insertion',
            desc: 'Accompagnement vers un emploi durable'
          }, {
            icon: Recycle,
            title: 'Recyclage',
            desc: 'Reconversion et mise à jour des compétences'
          }].map((pillar, index) => <Card key={index} className="text-center border-t-4 border-t-[#1E88E5] hover:shadow-lg transition-shadow duration-300" data-id="element-206">
                <CardContent className="pt-8 pb-6" data-id="element-207">
                  <div className="inline-flex items-center justify-center p-4 bg-blue-50 rounded-full mb-4" data-id="element-208">
                    <pillar.icon className="w-8 h-8 text-[#1E88E5]" data-id="element-209" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-210">
                    {pillar.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-211">{pillar.desc}</p>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Ateliers de Formation - Mars 2026 */}
      <section className="py-20 bg-gray-50" data-id="element-212">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
          <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-214">
            <div className="w-full lg:w-1/2" data-id="element-215">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl min-h-[450px] bg-gradient-to-br from-[#1E88E5] via-[#2C3E50] to-[#1976D2] flex flex-col items-center justify-center text-center p-8 group" data-id="element-216">
                <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-217"></div>
                <div className="absolute top-10 left-10 animate-bounce delay-100 opacity-20" data-id="element-218">
                  <GraduationCap className="w-16 h-16 text-white" data-id="element-219" />
                </div>
                <div className="absolute bottom-10 right-10 animate-bounce delay-300 opacity-20" data-id="element-220">
                  <Award className="w-16 h-16 text-white" data-id="element-221" />
                </div>
                <div className="absolute top-1/2 right-8 animate-pulse opacity-20" data-id="element-222">
                  <Sparkles className="w-12 h-12 text-yellow-300" data-id="element-223" />
                </div>
                <div className="relative z-10 transform transition-transform duration-500 group-hover:scale-105" data-id="element-224">
                  <div className="inline-block bg-white/20 backdrop-blur-md border border-white/30 rounded-full px-6 py-2 mb-6 shadow-lg" data-id="element-225">
                    <span className="flex items-center gap-2 text-white font-bold tracking-wider" data-id="element-226">
                      <span className="relative flex h-3 w-3" data-id="element-227">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-228"></span>
                        <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" data-id="element-229"></span>
                      </span>
                      PLACES LIMITÉES
                    </span>
                  </div>
                  <h2 className="text-5xl md:text-6xl font-extrabold text-white mb-2 tracking-tight drop-shadow-lg" data-id="element-230">
                    MARS 2026
                  </h2>
                  <div className="h-1 w-24 bg-yellow-400 mx-auto mb-6 rounded-full" data-id="element-231"></div>
                  <h3 className="text-2xl md:text-3xl font-bold text-blue-100 mb-8" data-id="element-232">
                    Transformez votre avenir
                  </h3>
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20 inline-block" data-id="element-233">
                    <p className="text-white font-medium" data-id="element-234">Session Intensive</p>
                    <p className="text-sm text-blue-200" data-id="element-235">
                      Entretien & Maintenance
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full lg:w-1/2" data-id="element-236">
              <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-237">
                Formation Professionnelle
              </span>
              <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-2" data-id="element-238">
                Ateliers de Formation – Mars 2026
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-239">
                Programme intensif de formation aux métiers de l'entretien et de
                la maintenance, incluant des modules théoriques et pratiques
                pour une professionnalisation complète.
              </p>

              <div className="bg-[#1E88E5]/10 border-l-4 border-[#1E88E5] p-4 mb-6" data-id="element-240">
                <p className="font-semibold text-gray-900 mb-2" data-id="element-241">
                  Nouveauté : Dispositif de placement intégré
                </p>
                <p className="text-gray-700" data-id="element-242">
                  Les participants aux ateliers de mars 2026 pourront intégrer,
                  selon leur profil, le dispositif de placement ADCC.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 mb-6" data-id="element-243">
                <h3 className="font-semibold text-gray-900 mb-4" data-id="element-244">
                  Programme :
                </h3>
                <div className="space-y-3" data-id="element-245">
                  {["Panels sur les métiers d'entretien et maintenance", 'Pitch CV avec jury', "Introduction aux techniques d'entretien, maintenance et hygiène", 'Compétences relationnelles et communication'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-246">
                      <CheckCircle2 className="w-5 h-5 text-[#1E88E5] flex-shrink-0 mt-0.5" data-id="element-247" />
                      <span className="text-sm text-gray-700" data-id="element-248">{item}</span>
                    </div>)}
                </div>
              </div>

              <Button className="gap-2" onClick={() => setActiveModal('ateliers')} data-id="element-249">
                S'inscrire aux ateliers
                <ArrowRight className="w-4 h-4" data-id="element-250" />
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Festival - Juin 2026 */}
      <section className="py-20 bg-white" data-id="element-251">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-252">
          <div className="flex flex-col lg:flex-row-reverse gap-12 items-center" data-id="element-253">
            <div className="w-full lg:w-1/2" data-id="element-254">
              <div className="relative rounded-2xl overflow-hidden shadow-xl min-h-[400px] bg-purple-100 flex items-center justify-center group" data-id="element-255">
                <img src="https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Festival des personnels de maison Juin 2026" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-256" />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300" data-id="element-257"></div>
                <div className="absolute top-4 right-4 bg-white px-4 py-2 rounded-full shadow-md z-10 flex items-center gap-2" data-id="element-258">
                  <Calendar className="w-5 h-5 text-[#1E88E5]" data-id="element-259" />
                  <span className="font-bold text-gray-900" data-id="element-260">Juin 2026</span>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-1/2" data-id="element-261">
              <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-262">
                Valorisation & Networking
              </span>
              <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-2" data-id="element-263">
                Festival des Personnels de Maison – Juin 2026
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-264">
                Un événement unique célébrant la dignité et les compétences des
                personnels de maison, combinant valorisation culturelle et
                opportunités professionnelles.
              </p>

              <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 mb-6" data-id="element-265">
                <h3 className="font-semibold text-gray-900 mb-4" data-id="element-266">
                  Au programme :
                </h3>
                <div className="space-y-3" data-id="element-267">
                  {['Célébrations culturelles et témoignages inspirants', 'Espace de rencontres professionnelles', 'Présentation de profils qualifiés aux employeurs', 'Ateliers de networking et speed-meeting', "Création de passerelles vers l'emploi"].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-268">
                      <Music className="w-5 h-5 text-[#1E88E5] flex-shrink-0 mt-0.5" data-id="element-269" />
                      <span className="text-sm text-gray-700" data-id="element-270">{item}</span>
                    </div>)}
                </div>
              </div>

              <Button variant="secondary" className="gap-2" onClick={() => setActiveModal('festival')} data-id="element-271">
                <PartyPopper className="w-4 h-4" data-id="element-272" />
                Participer au festival
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Placement & Insertion Section */}
      <section className="py-20 bg-gray-50" data-id="element-273">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-274">
          <div className="text-center mb-12" data-id="element-275">
            <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-276">
              Notre Pilier Stratégique
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4" data-id="element-277">
              Placement & Insertion Professionnelle
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-278">
              L'ADCC met en place un dispositif de placement progressif de
              personnels formés, en collaboration avec des familles,
              entreprises, institutions et partenaires.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-279">
            <Card className="bg-white" data-id="element-280">
              <CardContent className="p-8" data-id="element-281">
                <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-282">
                  Ce que nous proposons
                </h3>
                <div className="space-y-4" data-id="element-283">
                  {[{
                  title: 'Identification et préparation des profils formés',
                  desc: 'Évaluation des compétences et matching avec les besoins'
                }, {
                  title: 'Mise en relation avec des employeurs',
                  desc: 'Réseau de familles, entreprises et structures partenaires'
                }, {
                  title: "Sensibilisation aux bonnes pratiques d'emploi",
                  desc: 'Accompagnement des employeurs au respect des droits'
                }, {
                  title: 'Suivi post-placement et médiation si nécessaire',
                  desc: 'Accompagnement continu pour garantir la durabilité'
                }].map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-284">
                      <div className="flex-shrink-0 w-8 h-8 bg-blue-50 rounded-full flex items-center justify-center" data-id="element-285">
                        <span className="text-[#1E88E5] font-bold text-sm" data-id="element-286">
                          {index + 1}
                        </span>
                      </div>
                      <div data-id="element-287">
                        <h4 className="font-semibold text-gray-900 mb-1" data-id="element-288">
                          {item.title}
                        </h4>
                        <p className="text-sm text-gray-600" data-id="element-289">{item.desc}</p>
                      </div>
                    </div>)}
                </div>
              </CardContent>
            </Card>

            <Card className="bg-gradient-to-br from-[#1E88E5] to-[#1976D2] text-white" data-id="element-290">
              <CardContent className="p-8" data-id="element-291">
                <h3 className="text-xl font-bold mb-6" data-id="element-292">Notre Objectif</h3>
                <p className="text-lg text-blue-100 mb-8" data-id="element-293">
                  Créer un cadre structuré, sécurisé et respectueux pour
                  l'emploi des personnels de maison.
                </p>

                <div className="space-y-4" data-id="element-294">
                  {[{
                  title: 'Dignité',
                  desc: 'Respect des droits et de la personne'
                }, {
                  title: 'Transparence',
                  desc: "Clarté sur les conditions d'emploi"
                }, {
                  title: 'Durabilité',
                  desc: 'Insertion professionnelle à long terme'
                }].map((item, index) => <div key={index} className="bg-white/10 backdrop-blur-sm rounded-lg p-4" data-id="element-295">
                      <div className="flex items-center gap-3 mb-2" data-id="element-296">
                        <CheckCircle2 className="w-6 h-6" data-id="element-297" />
                        <h4 className="font-bold" data-id="element-298">{item.title}</h4>
                      </div>
                      <p className="text-sm text-blue-100" data-id="element-299">{item.desc}</p>
                    </div>)}
                </div>

                <div className="mt-8 space-y-3" data-id="element-300">
                  <Button variant="ghost" className="w-full bg-white text-[#1E88E5] hover:bg-gray-100" onClick={() => setActiveModal('employeur')} data-id="element-301">
                    <Building2 className="w-4 h-4 mr-2" data-id="element-302" />
                    Devenir employeur partenaire
                  </Button>
                  <Button variant="ghost" className="w-full bg-white/20 text-white hover:bg-white/30 border border-white/30" onClick={() => setActiveModal('recyclage')} data-id="element-303">
                    <RefreshCw className="w-4 h-4 mr-2" data-id="element-304" />
                    Recycler mon employé
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-100 text-center" data-id="element-305">
            <p className="text-2xl font-bold text-gray-900 mb-4" data-id="element-306">
              "Former sans débouché n'est pas suffisant. Notre engagement :
              transformer les compétences en opportunités d'emploi."
            </p>
            <p className="text-gray-600" data-id="element-307">
              Le placement professionnel constitue un indicateur clé de réussite
              de nos programmes.
            </p>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-white" data-id="element-308">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-309">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-310">
            Rejoignez notre réseau de partenaires
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-311">
            Que vous soyez une famille, une entreprise ou une institution,
            devenez partenaire de l'ADCC pour favoriser l'insertion
            professionnelle digne.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center flex-wrap" data-id="element-312">
            <Button size="lg" className="gap-2" onClick={() => setActiveModal('recruter')} data-id="element-313">
              <UserPlus className="w-5 h-5" data-id="element-314" />
              Recruter un personnel formé
            </Button>
            <Button variant="secondary" size="lg" className="gap-2" onClick={() => setActiveModal('partenariat')} data-id="element-315">
              <Handshake className="w-5 h-5" data-id="element-316" />
              Proposer un partenariat
            </Button>
            <Button variant="secondary" size="lg" className="gap-2" onClick={() => setActiveModal('recyclage')} data-id="element-317">
              <RefreshCw className="w-5 h-5" data-id="element-318" />
              Recycler mon employé
            </Button>
          </div>
        </div>
      </section>

      {/* Modal */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm overflow-y-auto" data-id="element-319">
          <div className="bg-white rounded-2xl w-full max-w-3xl shadow-2xl my-8 relative max-h-[90vh] overflow-y-auto" data-id="element-320">
            <button onClick={closeModal} className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100 text-gray-500 transition-colors z-10" data-id="element-321">
              <X className="w-6 h-6" data-id="element-322" />
            </button>

            <div className="p-8" data-id="element-323">
              <div className="text-center mb-8" data-id="element-324">
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-325">
                  {modalConfigs[activeModal].title}
                </h2>
                <p className="text-gray-600 mt-2" data-id="element-326">
                  {modalConfigs[activeModal].subtitle}
                </p>
              </div>

              {isSuccess ? <div className="text-center py-12" data-id="element-327">
                  <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-328">
                    <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-329" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-330">
                    Demande envoyée !
                  </h3>
                  <p className="text-gray-600 mb-8" data-id="element-331">
                    {modalConfigs[activeModal].successMessage}
                  </p>
                  <Button onClick={closeModal} data-id="element-332">Fermer</Button>
                </div> : <form ref={formRef} onSubmit={handleSubmit} className="space-y-6" data-id="element-333">
                  {/* Formulaire Ateliers */}
                  {activeModal === 'ateliers' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-334">
                      <div className="space-y-2" data-id="element-335">
                        <label className={labelClass} data-id="element-336">Nom complet *</label>
                        <input name="nom" type="text" required className={inputClass} placeholder="Votre nom de famille" data-id="element-337" />
                      </div>
                      <div className="space-y-2" data-id="element-338">
                        <label className={labelClass} data-id="element-339">Prénom *</label>
                        <input name="prenom" type="text" required className={inputClass} placeholder="Votre prénom" data-id="element-340" />
                      </div>
                      <div className="space-y-2" data-id="element-341">
                        <label className={labelClass} data-id="element-342">
                          Date de naissance *
                        </label>
                        <input name="dateNaissance" type="date" required className={inputClass} data-id="element-343" />
                      </div>
                      <div className="space-y-2" data-id="element-344">
                        <label className={labelClass} data-id="element-345">Sexe *</label>
                        <select name="sexe" required className={selectClass} data-id="element-346">
                          <option value="" data-id="element-347">Sélectionner...</option>
                          <option value="F" data-id="element-348">Femme</option>
                          <option value="H" data-id="element-349">Homme</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-350">
                        <label className={labelClass} data-id="element-351">
                          Situation professionnelle *
                        </label>
                        <select name="situation" required className={selectClass} data-id="element-352">
                          <option value="" data-id="element-353">Sélectionner...</option>
                          <option value="emploi" data-id="element-354">En emploi</option>
                          <option value="sans_emploi" data-id="element-355">Sans emploi</option>
                          <option value="etudiant" data-id="element-356">Étudiant(e)</option>
                          <option value="autre" data-id="element-357">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-358">
                        <label className={labelClass} data-id="element-359">Niveau d'études</label>
                        <select name="niveauEtudes" className={selectClass} data-id="element-360">
                          <option value="" data-id="element-361">Sélectionner...</option>
                          <option value="sans" data-id="element-362">Sans diplôme</option>
                          <option value="cep" data-id="element-363">CEP</option>
                          <option value="bepc" data-id="element-364">BEPC</option>
                          <option value="bac" data-id="element-365">BAC</option>
                          <option value="licence" data-id="element-366">Licence</option>
                          <option value="master" data-id="element-367">Master</option>
                          <option value="autre" data-id="element-368">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-369">
                        <label className={labelClass} data-id="element-370">Ville *</label>
                        <input name="ville" type="text" required className={inputClass} placeholder="Ex: Cotonou" data-id="element-371" />
                      </div>
                      <div className="space-y-2" data-id="element-372">
                        <label className={labelClass} data-id="element-373">Quartier *</label>
                        <input name="quartier" type="text" required className={inputClass} placeholder="Ex: Haie Vive" data-id="element-374" />
                      </div>
                      <div className="space-y-2" data-id="element-375">
                        <label className={labelClass} data-id="element-376">Téléphone *</label>
                        <input name="telephone" type="tel" required className={inputClass} placeholder="+229..." data-id="element-377" />
                      </div>
                      <div className="space-y-2" data-id="element-378">
                        <label className={labelClass} data-id="element-379">Email *</label>
                        <input name="email" type="email" required className={inputClass} placeholder="exemple@email.com" data-id="element-380" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-381">
                        <label className={labelClass} data-id="element-382">
                          Formation souhaitée
                        </label>
                        <select name="formationSouhaitee" className={selectClass} onChange={handleFormationChange} data-id="element-383">
                          <option value="" data-id="element-384">Sélectionner...</option>
                          <option value="entretien" data-id="element-385">
                            Entretien ménager professionnel
                          </option>
                          <option value="maintenance" data-id="element-386">
                            Maintenance technique
                          </option>
                          <option value="cuisine" data-id="element-387">Cuisine</option>
                          <option value="garde" data-id="element-388">Garde d'enfants</option>
                          <option value="autre" data-id="element-389">Autre</option>
                        </select>
                      </div>
                      {showFormationAutre && <div className="space-y-2 md:col-span-2" data-id="element-390">
                          <label className={labelClass} data-id="element-391">
                            Précisez la formation souhaitée *
                          </label>
                          <input type="text" required className={inputClass} placeholder="Décrivez la formation que vous souhaitez suivre" value={formationAutre} onChange={e => setFormationAutre(e.target.value)} data-id="element-392" />
                        </div>}
                      <div className="space-y-2 md:col-span-2" data-id="element-393">
                        <label className={labelClass} data-id="element-394">
                          Comment avez-vous connu l'ADCC ?
                        </label>
                        <select name="source" className={selectClass} data-id="element-395">
                          <option value="" data-id="element-396">Sélectionner...</option>
                          <option value="reseaux" data-id="element-397">Réseaux sociaux</option>
                          <option value="bouche" data-id="element-398">Bouche à oreille</option>
                          <option value="radio" data-id="element-399">Radio</option>
                          <option value="affiche" data-id="element-400">Affiche / Flyer</option>
                          <option value="autre" data-id="element-401">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-402">
                        <label className={labelClass} data-id="element-403">
                          Vos motivations (facultatif)
                        </label>
                        <textarea name="motivations" rows={3} className={inputClass + ' resize-none'} placeholder="Pourquoi souhaitez-vous suivre cette formation ?" data-id="element-404"></textarea>
                      </div>
                    </div>}

                  {/* Formulaire Festival */}
                  {activeModal === 'festival' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-405">
                      <div className="space-y-2" data-id="element-406">
                        <label className={labelClass} data-id="element-407">Nom complet *</label>
                        <input name="nom" type="text" required className={inputClass} placeholder="Votre nom" data-id="element-408" />
                      </div>
                      <div className="space-y-2" data-id="element-409">
                        <label className={labelClass} data-id="element-410">Prénom *</label>
                        <input name="prenom" type="text" required className={inputClass} placeholder="Votre prénom" data-id="element-411" />
                      </div>
                      <div className="space-y-2" data-id="element-412">
                        <label className={labelClass} data-id="element-413">Téléphone *</label>
                        <input name="telephone" type="tel" required className={inputClass} placeholder="+229..." data-id="element-414" />
                      </div>
                      <div className="space-y-2" data-id="element-415">
                        <label className={labelClass} data-id="element-416">Email *</label>
                        <input name="email" type="email" required className={inputClass} placeholder="exemple@email.com" data-id="element-417" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-418">
                        <label className={labelClass} data-id="element-419">Vous êtes *</label>
                        <select name="profil" required className={selectClass} data-id="element-420">
                          <option value="" data-id="element-421">Sélectionner...</option>
                          <option value="personnel" data-id="element-422">Personnel de maison</option>
                          <option value="employeur" data-id="element-423">Employeur</option>
                          <option value="partenaire" data-id="element-424">
                            Partenaire / Institution
                          </option>
                          <option value="media" data-id="element-425">Média / Presse</option>
                          <option value="autre" data-id="element-426">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-427">
                        <label className={labelClass} data-id="element-428">
                          Participation souhaitée
                        </label>
                        <select name="participation" className={selectClass} data-id="element-429">
                          <option value="" data-id="element-430">Sélectionner...</option>
                          <option value="visiteur" data-id="element-431">Visiteur</option>
                          <option value="exposant" data-id="element-432">Exposant / Stand</option>
                          <option value="temoin" data-id="element-433">Témoignage</option>
                          <option value="recruteur" data-id="element-434">Espace recrutement</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-435">
                        <label className={labelClass} data-id="element-436">
                          Message (facultatif)
                        </label>
                        <textarea name="message" rows={3} className={inputClass + ' resize-none'} placeholder="Informations complémentaires..." data-id="element-437"></textarea>
                      </div>
                    </div>}

                  {/* Formulaire Employeur Partenaire */}
                  {activeModal === 'employeur' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-438">
                      <div className="space-y-2" data-id="element-439">
                        <label className={labelClass} data-id="element-440">Nom complet *</label>
                        <input name="nom" type="text" required className={inputClass} placeholder="Votre nom" data-id="element-441" />
                      </div>
                      <div className="space-y-2" data-id="element-442">
                        <label className={labelClass} data-id="element-443">Prénom *</label>
                        <input name="prenom" type="text" required className={inputClass} placeholder="Votre prénom" data-id="element-444" />
                      </div>
                      <div className="space-y-2" data-id="element-445">
                        <label className={labelClass} data-id="element-446">Type d'employeur *</label>
                        <select name="typeEmployeur" required className={selectClass} data-id="element-447">
                          <option value="" data-id="element-448">Sélectionner...</option>
                          <option value="famille" data-id="element-449">Famille / Particulier</option>
                          <option value="entreprise" data-id="element-450">Entreprise</option>
                          <option value="institution" data-id="element-451">Institution / ONG</option>
                          <option value="hotel" data-id="element-452">Hôtel / Restaurant</option>
                          <option value="autre" data-id="element-453">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-454">
                        <label className={labelClass} data-id="element-455">Ville *</label>
                        <input name="ville" type="text" required className={inputClass} placeholder="Ex: Cotonou" data-id="element-456" />
                      </div>
                      <div className="space-y-2" data-id="element-457">
                        <label className={labelClass} data-id="element-458">Téléphone *</label>
                        <input name="telephone" type="tel" required className={inputClass} placeholder="+229..." data-id="element-459" />
                      </div>
                      <div className="space-y-2" data-id="element-460">
                        <label className={labelClass} data-id="element-461">Email *</label>
                        <input name="email" type="email" required className={inputClass} placeholder="exemple@email.com" data-id="element-462" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-463">
                        <label className={labelClass} data-id="element-464">Profils recherchés</label>
                        <select name="profilsRecherches" className={selectClass} data-id="element-465">
                          <option value="" data-id="element-466">Sélectionner...</option>
                          <option value="menage" data-id="element-467">Personnel d'entretien</option>
                          <option value="cuisine" data-id="element-468">Cuisinier(ère)</option>
                          <option value="garde" data-id="element-469">Garde d'enfants</option>
                          <option value="gardien" data-id="element-470">
                            Gardien / Agent de sécurité
                          </option>
                          <option value="chauffeur" data-id="element-471">Chauffeur</option>
                          <option value="polyvalent" data-id="element-472">Polyvalent</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-473">
                        <label className={labelClass} data-id="element-474">
                          Vos attentes (facultatif)
                        </label>
                        <textarea name="attentes" rows={3} className={inputClass + ' resize-none'} placeholder="Décrivez vos besoins et attentes..." data-id="element-475"></textarea>
                      </div>
                    </div>}

                  {/* Formulaire Recruter */}
                  {activeModal === 'recruter' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-476">
                      <div className="space-y-2" data-id="element-477">
                        <label className={labelClass} data-id="element-478">Nom complet *</label>
                        <input name="nom" type="text" required className={inputClass} placeholder="Votre nom" data-id="element-479" />
                      </div>
                      <div className="space-y-2" data-id="element-480">
                        <label className={labelClass} data-id="element-481">Prénom *</label>
                        <input name="prenom" type="text" required className={inputClass} placeholder="Votre prénom" data-id="element-482" />
                      </div>
                      <div className="space-y-2" data-id="element-483">
                        <label className={labelClass} data-id="element-484">Téléphone *</label>
                        <input name="telephone" type="tel" required className={inputClass} placeholder="+229..." data-id="element-485" />
                      </div>
                      <div className="space-y-2" data-id="element-486">
                        <label className={labelClass} data-id="element-487">Email *</label>
                        <input name="email" type="email" required className={inputClass} placeholder="exemple@email.com" data-id="element-488" />
                      </div>
                      <div className="space-y-2" data-id="element-489">
                        <label className={labelClass} data-id="element-490">Ville *</label>
                        <input name="ville" type="text" required className={inputClass} placeholder="Ex: Cotonou" data-id="element-491" />
                      </div>
                      <div className="space-y-2" data-id="element-492">
                        <label className={labelClass} data-id="element-493">Quartier</label>
                        <input name="quartier" type="text" className={inputClass} placeholder="Ex: Haie Vive" data-id="element-494" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-495">
                        <label className={labelClass} data-id="element-496">
                          Type de personnel recherché *
                        </label>
                        <select name="typePersonnel" required className={selectClass} data-id="element-497">
                          <option value="" data-id="element-498">Sélectionner...</option>
                          <option value="menage" data-id="element-499">
                            Personnel d'entretien ménager
                          </option>
                          <option value="cuisine" data-id="element-500">Cuisinier(ère)</option>
                          <option value="garde" data-id="element-501">
                            Garde d'enfants / Nounou
                          </option>
                          <option value="gardien" data-id="element-502">Gardien</option>
                          <option value="chauffeur" data-id="element-503">Chauffeur</option>
                          <option value="maintenance" data-id="element-504">
                            Agent de maintenance
                          </option>
                          <option value="polyvalent" data-id="element-505">
                            Personnel polyvalent
                          </option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-506">
                        <label className={labelClass} data-id="element-507">
                          Type de contrat souhaité
                        </label>
                        <select name="typeContrat" className={selectClass} data-id="element-508">
                          <option value="" data-id="element-509">Sélectionner...</option>
                          <option value="temps_plein" data-id="element-510">
                            Temps plein (logé ou non)
                          </option>
                          <option value="temps_partiel" data-id="element-511">Temps partiel</option>
                          <option value="ponctuel" data-id="element-512">
                            Intervention ponctuelle
                          </option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-513">
                        <label className={labelClass} data-id="element-514">
                          Date de début souhaitée
                        </label>
                        <input name="dateDebut" type="date" className={inputClass} data-id="element-515" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-516">
                        <label className={labelClass} data-id="element-517">
                          Description du poste et attentes *
                        </label>
                        <textarea name="description" rows={4} required className={inputClass + ' resize-none'} placeholder="Décrivez les tâches, horaires, conditions..." data-id="element-518"></textarea>
                      </div>
                    </div>}

                  {/* Formulaire Partenariat */}
                  {activeModal === 'partenariat' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-519">
                      <div className="space-y-2" data-id="element-520">
                        <label className={labelClass} data-id="element-521">
                          Nom de l'organisation *
                        </label>
                        <input name="organisation" type="text" required className={inputClass} placeholder="Nom de votre structure" data-id="element-522" />
                      </div>
                      <div className="space-y-2" data-id="element-523">
                        <label className={labelClass} data-id="element-524">
                          Type d'organisation *
                        </label>
                        <select name="typeOrganisation" required className={selectClass} data-id="element-525">
                          <option value="" data-id="element-526">Sélectionner...</option>
                          <option value="entreprise" data-id="element-527">Entreprise privée</option>
                          <option value="ong" data-id="element-528">ONG / Association</option>
                          <option value="institution" data-id="element-529">
                            Institution publique
                          </option>
                          <option value="fondation" data-id="element-530">Fondation</option>
                          <option value="media" data-id="element-531">Média</option>
                          <option value="autre" data-id="element-532">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-533">
                        <label className={labelClass} data-id="element-534">Nom du contact *</label>
                        <input name="nomContact" type="text" required className={inputClass} placeholder="Votre nom complet" data-id="element-535" />
                      </div>
                      <div className="space-y-2" data-id="element-536">
                        <label className={labelClass} data-id="element-537">Fonction *</label>
                        <input name="fonction" type="text" required className={inputClass} placeholder="Votre poste" data-id="element-538" />
                      </div>
                      <div className="space-y-2" data-id="element-539">
                        <label className={labelClass} data-id="element-540">Téléphone *</label>
                        <input name="telephone" type="tel" required className={inputClass} placeholder="+229..." data-id="element-541" />
                      </div>
                      <div className="space-y-2" data-id="element-542">
                        <label className={labelClass} data-id="element-543">Email *</label>
                        <input name="email" type="email" required className={inputClass} placeholder="exemple@email.com" data-id="element-544" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-545">
                        <label className={labelClass} data-id="element-546">
                          Type de partenariat envisagé
                        </label>
                        <select name="typePartenariat" className={selectClass} data-id="element-547">
                          <option value="" data-id="element-548">Sélectionner...</option>
                          <option value="financier" data-id="element-549">Soutien financier</option>
                          <option value="technique" data-id="element-550">Appui technique</option>
                          <option value="formation" data-id="element-551">
                            Co-animation de formations
                          </option>
                          <option value="emploi" data-id="element-552">
                            Offres d'emploi / Recrutement
                          </option>
                          <option value="communication" data-id="element-553">
                            Visibilité / Communication
                          </option>
                          <option value="autre" data-id="element-554">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-555">
                        <label className={labelClass} data-id="element-556">
                          Description de votre proposition *
                        </label>
                        <textarea name="proposition" rows={4} required className={inputClass + ' resize-none'} placeholder="Décrivez votre proposition de partenariat..." data-id="element-557"></textarea>
                      </div>
                    </div>}

                  {/* Formulaire Recyclage */}
                  {activeModal === 'recyclage' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-558">
                      <div className="space-y-2 md:col-span-2 bg-teal-50 p-4 rounded-lg border border-teal-200" data-id="element-559">
                        <h4 className="font-semibold text-teal-800 flex items-center gap-2" data-id="element-560">
                          <RefreshCw className="w-5 h-5" data-id="element-561" />
                          Informations sur l'employeur
                        </h4>
                      </div>
                      <div className="space-y-2" data-id="element-562">
                        <label className={labelClass} data-id="element-563">
                          Votre nom complet *
                        </label>
                        <input name="nomEmployeur" type="text" required className={inputClass} placeholder="Nom de l'employeur" data-id="element-564" />
                      </div>
                      <div className="space-y-2" data-id="element-565">
                        <label className={labelClass} data-id="element-566">Téléphone *</label>
                        <input name="telephoneEmployeur" type="tel" required className={inputClass} placeholder="+229..." data-id="element-567" />
                      </div>
                      <div className="space-y-2" data-id="element-568">
                        <label className={labelClass} data-id="element-569">Email *</label>
                        <input name="emailEmployeur" type="email" required className={inputClass} placeholder="exemple@email.com" data-id="element-570" />
                      </div>
                      <div className="space-y-2" data-id="element-571">
                        <label className={labelClass} data-id="element-572">Ville *</label>
                        <input name="villeEmployeur" type="text" required className={inputClass} placeholder="Ex: Cotonou" data-id="element-573" />
                      </div>

                      <div className="space-y-2 md:col-span-2 bg-blue-50 p-4 rounded-lg border border-blue-200 mt-4" data-id="element-574">
                        <h4 className="font-semibold text-blue-800 flex items-center gap-2" data-id="element-575">
                          <Users className="w-5 h-5" data-id="element-576" />
                          Informations sur l'employé à recycler
                        </h4>
                      </div>
                      <div className="space-y-2" data-id="element-577">
                        <label className={labelClass} data-id="element-578">Nom de l'employé *</label>
                        <input name="nomEmploye" type="text" required className={inputClass} placeholder="Nom complet de l'employé" data-id="element-579" />
                      </div>
                      <div className="space-y-2" data-id="element-580">
                        <label className={labelClass} data-id="element-581">Poste actuel *</label>
                        <select name="posteActuel" required className={selectClass} data-id="element-582">
                          <option value="" data-id="element-583">Sélectionner...</option>
                          <option value="menage" data-id="element-584">Personnel d'entretien</option>
                          <option value="cuisine" data-id="element-585">Cuisinier(ère)</option>
                          <option value="garde" data-id="element-586">Garde d'enfants</option>
                          <option value="gardien" data-id="element-587">Gardien</option>
                          <option value="chauffeur" data-id="element-588">Chauffeur</option>
                          <option value="polyvalent" data-id="element-589">Polyvalent</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-590">
                        <label className={labelClass} data-id="element-591">
                          Ancienneté chez vous
                        </label>
                        <select name="anciennete" className={selectClass} data-id="element-592">
                          <option value="" data-id="element-593">Sélectionner...</option>
                          <option value="moins_1" data-id="element-594">Moins d'1 an</option>
                          <option value="1_3" data-id="element-595">1 à 3 ans</option>
                          <option value="3_5" data-id="element-596">3 à 5 ans</option>
                          <option value="plus_5" data-id="element-597">Plus de 5 ans</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-598">
                        <label className={labelClass} data-id="element-599">
                          Téléphone de l'employé
                        </label>
                        <input name="telephoneEmploye" type="tel" className={inputClass} placeholder="+229..." data-id="element-600" />
                      </div>

                      <div className="space-y-2 md:col-span-2 bg-amber-50 p-4 rounded-lg border border-amber-200 mt-4" data-id="element-601">
                        <h4 className="font-semibold text-amber-800 flex items-center gap-2" data-id="element-602">
                          <GraduationCap className="w-5 h-5" data-id="element-603" />
                          Formation de recyclage souhaitée
                        </h4>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-604">
                        <label className={labelClass} data-id="element-605">
                          Points de formation souhaités *
                        </label>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-2" data-id="element-606">
                          {["Techniques d'entretien avancées", 'Hygiène et sécurité', 'Communication et savoir-être', 'Gestion du temps et organisation', 'Cuisine et nutrition', "Garde d'enfants et pédagogie", 'Maintenance et petites réparations', 'Premiers secours'].map((item, i) => <label key={i} className="flex items-center gap-2 p-2 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer" data-id="element-607">
                              <input name="pointsFormation" type="checkbox" value={item} className="w-4 h-4 text-[#1E88E5] rounded" data-id="element-608" />
                              <span className="text-sm text-gray-700" data-id="element-609">
                                {item}
                              </span>
                            </label>)}
                        </div>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-610">
                        <label className={labelClass} data-id="element-611">
                          Autres points de formation (précisez)
                        </label>
                        <input name="autresPoints" type="text" className={inputClass} placeholder="Autres compétences à développer..." data-id="element-612" />
                      </div>
                      <div className="space-y-2" data-id="element-613">
                        <label className={labelClass} data-id="element-614">
                          Période souhaitée *
                        </label>
                        <select name="periodeSouhaitee" required className={selectClass} data-id="element-615">
                          <option value="" data-id="element-616">Sélectionner...</option>
                          <option value="urgent" data-id="element-617">Dès que possible</option>
                          <option value="1mois" data-id="element-618">Dans le mois</option>
                          <option value="3mois" data-id="element-619">
                            Dans les 3 prochains mois
                          </option>
                          <option value="flexible" data-id="element-620">Flexible</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-621">
                        <label className={labelClass} data-id="element-622">
                          Durée de formation souhaitée
                        </label>
                        <select name="dureeSouhaitee" className={selectClass} data-id="element-623">
                          <option value="" data-id="element-624">Sélectionner...</option>
                          <option value="1jour" data-id="element-625">1 journée</option>
                          <option value="2_3jours" data-id="element-626">2-3 jours</option>
                          <option value="1semaine" data-id="element-627">1 semaine</option>
                          <option value="flexible" data-id="element-628">À définir ensemble</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-629">
                        <label className={labelClass} data-id="element-630">
                          Observations complémentaires
                        </label>
                        <textarea name="observations" rows={3} className={inputClass + ' resize-none'} placeholder="Points particuliers à signaler, difficultés observées..." data-id="element-631"></textarea>
                      </div>
                    </div>}

                  <div className="pt-4 border-t border-gray-100 flex justify-end gap-4" data-id="element-632">
                    <Button type="button" variant="ghost" onClick={closeModal} data-id="element-633">
                      Annuler
                    </Button>
                    <Button type="submit" disabled={isSubmitting} className="min-w-[200px]" data-id="element-634">
                      {isSubmitting ? <>
                          <Loader2 className="w-4 h-4 mr-2 animate-spin" data-id="element-635" />
                          Envoi en cours...
                        </> : 'Soumettre'}
                    </Button>
                  </div>
                </form>}
            </div>
          </div>
        </div>}
    </Layout>;
}